module.exports = __webpack_public_path__ + "media/img/home/clients-map/neth-7886aa4d00020cb60e15dde2643e1bb6.png";